import initialState from '../store/initialState'
import usersTypes from '../constants/usersTypes'

// const { toast } = window.M

export default function usersReducer(state = initialState.users, action) {
  switch (action.type) {

    case usersTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case usersTypes.reset_user: {
      return {
        ...initialState.users,
        items: state.items,
        user: state.user,
        genders: state.genders,
        ages: state.ages,
        educations: state.educations,
        industries: state.industries,
        pagination: state.pagination
      }
    }

    case usersTypes.clear_user: {
      return {
        ...initialState.users,
        user: {
        },
        items: state.items,
        totals: state.totals,
        pagination: state.pagination,
      }
    }
    // GET
    case usersTypes.delete.request:
    case usersTypes.get.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case usersTypes.get.success: {
      const {user, ages, genders, industries, educations} = action.payload
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        user, ages, genders, industries, educations,
        errors: []
      }
    }

    case usersTypes.delete.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: []
      }
    }

    case usersTypes.delete.failure:
    case usersTypes.get.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // UPDATE
    case usersTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case usersTypes.update.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        errors: [],
        user: action.payload
      }
    }

    case usersTypes.update.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    // INDEX
    case usersTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case usersTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.users,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
        errors: []
      }
    }

    case usersTypes.index.select: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        select_items: action.payload.users,
        errors: []
      }
    }

    case usersTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    // LOCK = REVOKE, UNLOCK = ENABLE
    case usersTypes.lock.request:{
      return {
        ...state,
        setting_status: true,
        set_status: false
      };
    }

    case usersTypes.lock.success:{
      return {
        ...state,
        setting_status: false,
        set_status: true,
        items: action.payload.users,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      };
    }

    case usersTypes.lock.single:{
      const {active, locked, confirmed } = action.payload.user
      return {
        ...state,
        setting_status: false,
        set_status: true,
        user: {
          ...state.user,
          active: active,
          locked: locked,
          confirmed: confirmed
        }
      };
    }

    case usersTypes.lock.failure:{
      return {
        ...state,
        setting_status: false,
        set_status: false,
        errors: action.payload
      }
    }


    // // DELETE
    // case usersTypes.destroy.request: {
    //   return {
    //     ...state,
    //     fetching_single: true,
    //     fetched_single: false,
    //     errors: []
    //   }
    // }
    //
    // case usersTypes.destroy.success: {
    //   return {
    //     ...state,
    //     fetching_single: false,
    //     fetched_single: true,
    //     errors: [],
    //     items: action.payload.users,
    //     pagination: action.payload.pagination
    //   }
    // }
    //
    // case usersTypes.destroy.failure: {
    //   return {
    //     ...state,
    //     fetching_single: false,
    //     fetched_single: false,
    //     errors: action.payload
    //   }
    // }


    // CHANGE PASSWORD
    case usersTypes.change_password.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case usersTypes.change_password.success: {
      // toast({
      //   html: "Password updated successfully"
      // })
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        random: Math.random() // to close password inline form
      }
    }

    case usersTypes.change_password.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // CREATE
    case usersTypes.create.init: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case usersTypes.create.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case usersTypes.create.success: {
      // toast({
      //   html: "User created successfully"
      // })
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        user: action.payload,
        // items: action.payload.users,
        // pagination: action.payload.pagination,
        errors: []
      }
    }

    case usersTypes.create.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    case usersTypes.xlsx.request: {
      return {
        ...state,
        fetching_xlsx: true,
        errors: []
      }
    }

    case usersTypes.xlsx.success: {
      return {
        ...state,
        fetching_xlsx: false,
        errors: []
      }
    }

    case usersTypes.xlsx.failure: {
      return {
        ...state,
        fetching_xlsx: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/usersReducer.js